import { render, staticRenderFns } from "./wtRadioText.component.vue?vue&type=template&id=087900cb&scoped=true&"
import script from "./wtRadioText.component.vue?vue&type=script&lang=js&"
export * from "./wtRadioText.component.vue?vue&type=script&lang=js&"
import style0 from "./wtRadioText.component.vue?vue&type=style&index=0&id=087900cb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "087900cb",
  null
  
)

export default component.exports